/**
 * Created by Daniela on 26/09/2016.
 */
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { MedidaListComponent } from "./medida-list/medida-list.component";
import { newRoute, editRoute } from "../../shared/services/data.service";
import { MedidaFormComponent } from "./medida-form/medida-form.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class MedidasRoutingModule {}

export  const medidasRoutes: any[] = [
    {
        path: '',
        component: MedidaListComponent
    },
    {
        path: newRoute,
        component: MedidaFormComponent
    },
    {
        path: editRoute + '/:id',
        component: MedidaFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/medidas.routing.ts
 **/